

const STORAGE_KEY = "contractMenuSettings";

export const ContractMenuStorage = {
  get: () => {
    const data = localStorage.getItem(STORAGE_KEY);
    return data ? JSON.parse(data) : [];
  },

  set: (data) => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
  },

  clear: () => {
    localStorage.removeItem(STORAGE_KEY);
  },
};
